/*
	This is used for client tags, matter tags, matter types, office/branch, document types, document statuses
*/
import {
	LIST_PREFIX_REQUEST,
	LIST_PREFIX_SUCCESS,
	LIST_PREFIX_FAILURE,
	DOCUMENT_DETAILS_SUCCESS,
	DOCUMENT_DETAILS_FAILURE,
	DOCUMENT_DETAILS_REQUEST,
	UNMOUNT_DOCUMENT_DETAILS,
	UPLOAD_NEW_VERSION_REQUEST,
	UPLOAD_NEW_VERSION_PROGRESS,
	UPLOAD_NEW_VERSION_SUCCESS,
	CREATE_NEW_FOLDER_REQUEST,
	CREATE_NEW_FOLDER_SUCCESS,
	CREATE_NEW_FOLDER_FAILURE,
	GET_NOTE_SUCCESS,
	GET_NOTE_FAILURE,
	UNMOUNT_NOTE_EDITOR,
	CREATE_NOTE_SUCCESS,
	ACCESS_CREATE_NOTE,
	SET_DOCUMENT_LOCK_SUCCESS,
	FETCH_RECENT_DOCS_REQUEST_NOGLOBAL,
	FETCH_RECENT_DOCS_SUCCESS_NOGLOBAL,
	FETCH_FAVORITE_DOCS_REQUEST_NOGLOBAL,
	FETCH_FAVORITE_DOCS_SUCCESS_NOGLOBAL,
	UPDATE_DOCUMENT_PROPERTIES_REQUEST,
	UPDATE_DOCUMENT_PROPERTIES_SUCCESS,
	UPDATE_DOCUMENT_PROPERTIES_FAILURE,
	RENAME_REQUEST,
	RENAME_SUCCESS,
	RENAME_FAILURE,
	UPDATE_DOCUMENT_VERSION_COMMENT_REQUEST,
	UPDATE_DOCUMENT_VERSION_COMMENT_SUCCESS,
	UPDATE_DOCUMENT_VERSION_COMMENT_FAILURE,
	OPEN_GLOBAL_SNACKBAR,
	OPEN_PERSISTENT_SNACKBAR,
	DOCUMENT_PREVIEW_CONTENT_SUCCESS,
	DOCUMENT_PREVIEW_CONTENT_FAILURE,
	FETCH_DOCUMENT_PREVIEW_CONTENT,
	MULTI_DOWNLOAD_REQUEST,
	MULTI_DOWNLOAD_SUCCESS,
	MULTI_DOWNLOAD_STARTED,
	MULTI_DOWNLOAD_FAILURE,
	EXTERNAL_SEND_REQUEST,
	EXTERNAL_SEND_SUCCESS,
	EXTERNAL_SEND_STARTED,
	EXTERNAL_SEND_FAILURE,
	GET_EXTERNAL_SAVED_EMAIL_ADDRESSES_SUCCESS,
	CLOSE_GLOBAL_SNACKBAR,
	CONVERT_TO_PDF_REQUEST,
	CONVERT_TO_PDF_SUCCESS,
	CONVERT_TO_PDF_STARTED,
	CONVERT_TO_PDF_CANCELED,
	DELETE_DOCUMENT_VERSION_REQUEST,
	DELETE_DOCUMENT_VERSION_SUCCESS,
	DELETE_DOCUMENT_VERSION_FAILURE,
	DELETE_MAJOR_VERSION_REQUEST,
	DELETE_MAJOR_VERSION_SUCCESS,
	DELETE_MAJOR_VERSION_FAILURE,
	PROMOTE_DOCUMENT_VERSION_REQUEST,
	PROMOTE_DOCUMENT_VERSION_SUCCESS,
	PROMOTE_DOCUMENT_VERSION_FAILURE,
} from "./types";

import { openGlobalDialog } from "./globalEditDialogActions";

import { openLauncherLink } from "./launcherActions";

import {
	archiveMultiselect,
	deleteMultiselect,
	restoreFromArchiveMultiselect,
	restoreMultiselect,
	restoreMultiSelectTrashPage,
} from "./multiselectActions";

import {
	beginBulkDownloadJob,
	beginBulkExternalSendJob,
	beginConvertToPDFJob,
	handlePermanentDeleteFlow,
} from "./jobProgressActions";

import { beginRenameJob } from "./jobProgressActions";

import { showMatterDetails } from "./matterActions";

import {
	isFileTypeCompatibleWithInline,
	isFileTypeCompatibleWithLitera,
	splitFilename,
} from "../utilities/utilities";

import API from "../utilities/LocalApiProxy";
import {
	TRASH_LIFECYCLE_STATUS,
	ARCHIVE_LIFECYCLE_STATUS,
	NORMAL_LIFECYCLE_STATUS,
} from "../utilities/lifecycleStatus";

import React from "react";
import { Link } from "react-router-dom";

import config from "../config/legalworks.frontend.config";
import {
	getRecentlyViewedClients,
	getRecentlyViewMatters,
} from "./browserLocalstorageActions";
import {
	isPreventActionOnDeletedResource,
	isRateLimitError,
} from "./errorActions";

function directoryMap(directories) {
	return directories.map((item) => {
		return {
			type: "Folder",
			id: item.id,
			filename: item.name,
			fullpath: item.path + item.name + "/",
			isFavorite: item.isFavorite,
			folderLifecycleStatus: item.folderLifecycleStatus,
		};
	});
}
function documentMap(documents, basepath) {
	return documents.map((item) => {
		return {
			type: "File",
			lwid: item.prefix,
			id: item.documentID,
			filename: item.filename,
			isFavorite: item.isFavorite,
			createdBy: item.createdBy,
			filesize: item.filesize,
			lockedBy: item.lockedBy,
			lockedBySub: item.lockedBySub,
			lockStatus: item.lockStatus,
			documentStatus: item.documentStatus,
			documentType: item.documentType,
			createdAt: item.createdAt,
			lastModified: item.lastModified,
			versionNumber: item.versionNumber,
			currentMajorVersion: item.currentMajorVersion,
			currentMinorVersion: item.currentMinorVersion,
			documentLifecycleStatus: item.documentLifecycleStatus,
			size: item.filesize,
			tags: item.tags,
			fullpath: basepath + item.filename,
			isFileTypeCompatibleWithLitera: isFileTypeCompatibleWithLitera(
				item.filename
			),
			isFileTypeCompatibleWithInline: isFileTypeCompatibleWithInline(
				item.filename
			),
			notes: item.notes,
		};
	});
}
function listEmailDirectory(matterID, basepath, errorHandlingArgs) {
	return API.get(
		"/email/list",
		{ queryParams: { matterID, basepath } },
		errorHandlingArgs
	).then((result) => {
		var emails = result.mysql.emails.map((item) => {
			return {
				...item,
				type: "Email",
			};
		});
		var directories = directoryMap(result.mysql.directories);
		return Promise.resolve({
			emails,
			directories,
			directoryID: result.mysql.directoryID,
			matter: result.mysql.matter[0],
			documentListDataColumnsAreAbbreviated:
				result.mysql.documentListDataColumnsAreAbbreviated,
			directoryHierarchy: result.mysql.directoryHierarchy,
			folderLifecycleStatus: result.mysql.folderLifecycleStatus,
			matterLifecycleStatus: result.mysql.matterLifecycleStatus,
		});
	});
}

//basepath should end with a /
export function listDirectory(
	matterID,
	basepath,
	history,
	includeMatterDetail
) {
	return function (dispatch) {
		var matterRoot = basepath.split("/")[0];
		// identifies which folder documentList holds, so a failed load of
		// another folder doesn't show this one's items as its own
		const listKey = `${matterID}:${basepath}`;
		const errorHandlingArgs = {};
		const handleFailure = (err) => {
			const rateLimited = isRateLimitError(err);
			dispatch({
				type: LIST_PREFIX_FAILURE,
				payload: { rateLimited, listKey, matterRoot },
			});
			// stay on the page to show the last loaded items as out of date
			if (!rateLimited) {
				window.globalHistory.push("/");
			}
		};
		dispatch({
			type: LIST_PREFIX_REQUEST,
		});
		if (matterRoot === "email") {
			listEmailDirectory(matterID, basepath, errorHandlingArgs)
				.then((res) => {
					dispatch({
						type: LIST_PREFIX_SUCCESS,
						payload: {
							originalPrefix: basepath,
							listKey,
							documents: res.emails.concat(res.directories),
							matterRoot,
							directoryID: res.directoryID,
							documentListDataColumnsAreAbbreviated:
								res.documentListDataColumnsAreAbbreviated,
							directoryHierarchy: res.directoryHierarchy,
							folderLifecycleStatus: res.folderLifecycleStatus,
							matterLifecycleStatus: res.matterLifecycleStatus,
						},
					});
					includeMatterDetail &&
						showMatterDetails(res.matter)(dispatch);
				})
				.catch(handleFailure);
		} else if (
			matterRoot === "docs" ||
			matterRoot === "public" ||
			matterRoot === "private"
		) {
			API.get(
				"/document/list",
				{ queryParams: { matterID, basepath } },
				errorHandlingArgs
			)
				.then((result) => {
					var files = documentMap(result.mysql.files, basepath);
					var directories = directoryMap(result.mysql.directories);

					dispatch({
						type: LIST_PREFIX_SUCCESS,
						payload: {
							originalPrefix: basepath,
							listKey,
							documents: files.concat(directories),
							matterRoot,
							directoryID: result.mysql.directoryID,
							documentListDataColumnsAreAbbreviated:
								result.mysql
									.documentListDataColumnsAreAbbreviated,
							directoryHierarchy: result.mysql.directoryHierarchy,
							folderLifecycleStatus:
								result.mysql.folderLifecycleStatus,
							matterLifecycleStatus:
								result.mysql.matterLifecycleStatus,
						},
					});

					includeMatterDetail &&
						showMatterDetails(result.mysql.matter[0])(dispatch);
				})
				.catch(handleFailure);
		} else if (matterRoot === "notes") {
			API.get(
				"/notes/list",
				{ queryParams: { matterID, basepath } },
				errorHandlingArgs
			)
				.then((result) => {
					var notes = result.mysql.notes
						.map((n) => ({ ...n, type: "Note" }))
						.concat(directoryMap(result.mysql.directories));
					dispatch({
						type: LIST_PREFIX_SUCCESS,
						payload: {
							originalPrefix: basepath,
							listKey,
							documents: notes,
							matterRoot,
							directoryID: result.mysql.directoryID,
							documentListDataColumnsAreAbbreviated:
								result.mysql
									.documentListDataColumnsAreAbbreviated,
							directoryHierarchy: result.mysql.directoryHierarchy,
							folderLifecycleStatus:
								result.mysql.folderLifecycleStatus,
							matterLifecycleStatus:
								result.mysql.matterLifecycleStatus,
						},
					});
					includeMatterDetail &&
						showMatterDetails(result.mysql.matter[0])(dispatch);
				})
				.catch(handleFailure);
		}
	};
}

// Non-Redux variant of listDirectory, used by the AI "Add Context" Browse
// tab. It navigates matters/folders on its own without dispatching into the
// shared document-list Redux state, since that state also drives the real
// Documents/Email/Notes pages and shouldn't be clobbered by browsing inside
// a chat modal. Reuses the same mapping helpers/endpoints as listDirectory.
export function fetchBrowseDirectory(matterID, basepath) {
	const matterRoot = basepath.split("/")[0];
	if (matterRoot === "email") {
		return listEmailDirectory(matterID, basepath).then((res) => ({
			matterRoot,
			items: res.emails.concat(res.directories),
			directoryID: res.directoryID,
			directoryHierarchy: res.directoryHierarchy,
			folderLifecycleStatus: res.folderLifecycleStatus,
			matterLifecycleStatus: res.matterLifecycleStatus,
		}));
	} else if (matterRoot === "notes") {
		return API.get("/notes/list", {
			queryParams: { matterID, basepath },
		}).then((result) => ({
			matterRoot,
			items: result.mysql.notes
				.map((n) => ({ ...n, type: "Note" }))
				.concat(directoryMap(result.mysql.directories)),
			directoryID: result.mysql.directoryID,
			directoryHierarchy: result.mysql.directoryHierarchy,
			folderLifecycleStatus: result.mysql.folderLifecycleStatus,
			matterLifecycleStatus: result.mysql.matterLifecycleStatus,
		}));
	}
	// docs / public / private all list through the same document endpoint
	return API.get("/document/list", {
		queryParams: { matterID, basepath },
	}).then((result) => ({
		matterRoot,
		items: documentMap(result.mysql.files, basepath).concat(
			directoryMap(result.mysql.directories)
		),
		directoryID: result.mysql.directoryID,
		directoryHierarchy: result.mysql.directoryHierarchy,
		folderLifecycleStatus: result.mysql.folderLifecycleStatus,
		matterLifecycleStatus: result.mysql.matterLifecycleStatus,
	}));
}

export function getNote(noteID) {
	return function (dispatch) {
		return API.get("/notes", { queryParams: { id: noteID } })
			.then((res) => {
				dispatch({
					type: GET_NOTE_SUCCESS,
					payload: {
						note: res.mysql,
					},
				});
				return res.mysql;
			})
			.catch(() => {
				window.globalHistory.push("/");
				dispatch({ type: GET_NOTE_FAILURE });
			});
	};
}
function handleNoteSaveError(dispatch, err) {
	if (isPreventActionOnDeletedResource(err?.lxwErrorCode)) {
		// handled in errorActions
	} else if (err?.lxwErrorCode === 6800) {
		const message =
			"We are unable to save this note. Please reduce it's length to save it.";
		dispatch({
			type: OPEN_PERSISTENT_SNACKBAR,
			payload: {
				message,
				variant: "error",
			},
		});
	}
	console.error(err);
}
// Fetches a note without storing it, e.g. to compare against unsaved changes
export function fetchNoteForComparisonOnConflict(noteID) {
	return function () {
		return API.get("/notes", { queryParams: { id: noteID } }).then(
			(res) => res.mysql
		);
	};
}
// Resolves with the note's new { modifiedOnUnix, modifiedOn, modifiedBy }.
// Rejects with NOTE_EDIT_CONFLICT if the note was saved by someone else
// after expectedModifiedOnUnix
export function updateNote(id, noteData) {
	return function (dispatch) {
		const { name, content, noteContentType, expectedModifiedOnUnix } =
			noteData;
		return API.post(
			"/notes/v2/update",
			{
				body: {
					id,
					name,
					content,
					noteContentType,
					expectedModifiedOnUnix,
				},
			},
			// NoteEditor shows the rate limit and retries the save
			{ suppressRateLimitSnackbar: true }
		)
			.then((res) => res.mysql)
			.catch((err) => {
				handleNoteSaveError(dispatch, err);
				throw err;
			});
	};
}
// Resolves with { matterNoteID } of the newly created note
export function createNote(matterID, directoryID, noteData) {
	return function (dispatch) {
		const { name, content, noteContentType } = noteData;
		return API.put(
			"/notes/create",
			{
				body: { matterID, directoryID, name, content, noteContentType },
			},
			// NoteEditor shows the rate limit and retries the save
			{ suppressRateLimitSnackbar: true }
		)
			.then((res) => {
				dispatch({
					type: CREATE_NOTE_SUCCESS,
				});
				return res.mysql;
			})
			.catch((err) => {
				handleNoteSaveError(dispatch, err);
				throw err;
			});
	};
}
export function createNoteInRootOfMatter({
	matterID,
	name,
	content,
	noteContentType,
}) {
	return function (dispatch) {
		API.put("/notes/createInRootOfMatter", {
			body: { matterID, name, content, noteContentType },
		})
			.then((res) => {
				const { matterNoteID } = res.mysql;
				const successMessage = (
					<div style={{ textAlign: "left" }}>
						Matter Note created Notes tab of this matter.{" "}
						<a
							target="_blank"
							rel="noopener noreferrer"
							href={`https://${config.domain}/notes/${matterNoteID}`}
							className="lw-internal-action-link white"
							onClick={() => {
								dispatch({
									type: CLOSE_GLOBAL_SNACKBAR,
								});
							}}
						>
							Open Matter Note
						</a>
						.
					</div>
				);
				dispatch({
					type: OPEN_PERSISTENT_SNACKBAR,
					payload: {
						message: successMessage,
						variant: "success",
					},
				});
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					// handled in errorActions
				} else if (err.lxwErrorCode === 6800) {
					const message =
						"We are unable to save this AI conversation to a matter note as it has become too long. You may either copy the contents or copy it to an email.";
					dispatch({
						type: OPEN_PERSISTENT_SNACKBAR,
						payload: {
							message,
							variant: "error",
						},
					});
				} else {
					const message = "Matter Note could not be created";
					console.error(message);
					console.error(err);
					dispatch({
						type: OPEN_PERSISTENT_SNACKBAR,
						payload: {
							message,
							variant: "error",
						},
					});
				}
			});
	};
}
export function unmountNoteEditor() {
	return function (dispatch) {
		dispatch({ type: UNMOUNT_NOTE_EDITOR });
	};
}
export function accessCreateNote(matterID, directoryID, fullpath) {
	return function (dispatch) {
		dispatch({
			type: ACCESS_CREATE_NOTE,
			payload: {
				matterID,
				directoryID,
				fullpath,
			},
		});
	};
}
export function getDocumentDetails(documentID) {
	return function (dispatch) {
		dispatch({ type: DOCUMENT_DETAILS_REQUEST });
		API.get("/document", { queryParams: { documentID } })
			.then((res) => {
				dispatch({
					type: DOCUMENT_DETAILS_SUCCESS,
					payload: { ...res.mysql },
				});
			})
			.catch(() => {
				dispatch({
					type: DOCUMENT_DETAILS_FAILURE,
				});
				window.globalHistory.push("/");
			});
	};
}

function getDocumentDetailsBackground(documentID) {
	return function (dispatch) {
		API.get("/document", { queryParams: { documentID } })
			.then((res) => {
				dispatch({
					type: DOCUMENT_DETAILS_SUCCESS,
					payload: { ...res.mysql },
				});
			})
			.catch(() => {
				dispatch({ type: DOCUMENT_DETAILS_FAILURE });
				window.globalHistory.push("/");
			});
	};
}

export function getSignedUrlAndDownload(key, rootS3Folder, versionID) {
	return function (dispatch) {
		var queryParams = {
			key,
			rootS3Folder,
			operation: "getObject",
		};
		if (versionID) {
			queryParams.versionID = versionID;
		}
		API.get("/signed", { queryParams })
			.then((res) => {
				window.location.href = res.mysql.url;
				dispatch({
					type: "GET_SIGNED_URL_SUCCESS",
				});
			})
			.catch((err) => console.log(err));
	};
}

export function getSignedUrlForDocumentAndDownload(documentID, versionID) {
	return function (dispatch) {
		API.get("/signedGetIgnoreLock", {
			queryParams: { documentID, versionID },
		})
			.then((res) => {
				if (res.mysql.noS3Object) {
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						payload: {
							message:
								"This Document could not be downloaded.  Please contact LexWorkplace Support",
							variant: "error",
							loadingSpinnerVisible: false,
							allowClose: true,
							autoHideDuration: null,
						},
					});
				} else {
					//This downloads the file to the users downloads folder using the filename that is defined by the "response-content-disposition=attachment" property of the header in the pre-signed URL
					window.location.href = res.mysql.url;
					dispatch({
						type: "GET_SIGNED_URL_SUCCESS",
					});
				}
			})
			.catch((err) => console.log(err));
	};
}

// documentID: row.original.id,
// fileName: row.original.filename,
// matterID: this.props.matterID,
// convertAction: "createPDF",
// basepath: this.props.originalPrefix,
export function convertDocumentToPDF({
	sourceDocumentID,
	fileToConvert,
	matterID,
	actionType,
	duplicatePDFDocInfo,
	basepath,
}) {
	return function (dispatch) {
		var newDocumentID;
		const successCallback = (jobData) => {
			var myObject = JSON.parse(jobData.jobData);
			// jobData = {
			// 	"manifestFilename": "7e8491b7c3be86284baa5ccbdbbb63071fad1244.csv",
			// 	"matterID": "85",
			// 	"documentID": 81243,
			// 	"userLocationWhenActionWasTaken": "https://lexworkplace.local:3000/matters/85/docs/a/b/",
			// 	"parentDirectoryPath": "docs/a/b/"
			// }
			newDocumentID = myObject.documentID;

			const successMessage = (
				<div style={{ textAlign: "left" }}>
					Your PDF Conversion is Complete and Available{" "}
					<Link
						className="lw-internal-action-link white"
						to={`/docs/${newDocumentID}`}
						onClick={() => {
							dispatch({
								type: CLOSE_GLOBAL_SNACKBAR,
							});
						}}
					>
						Here
					</Link>
					.
				</div>
			);
			if (
				basepath &&
				myObject.userLocationWhenActionWasTaken &&
				myObject.userLocationWhenActionWasTaken === window.location.href
			) {
				listDirectory(myObject.matterID, basepath)(dispatch);
			}
			dispatch({
				type: CONVERT_TO_PDF_SUCCESS,
				payload: {
					message: successMessage,
					loadingSpinnerVisible: false,
					allowClose: true,
					autoHideDuration: null,
				},
			});
		};

		dispatch({ type: CONVERT_TO_PDF_REQUEST });
		API.post("/document/convert", {
			body: {
				sourceDocumentID,
				matterID,
				actionType,
				duplicatePDFDocInfo,
				userLocationWhenActionWasTaken: window.location.href,
				parentDirectoryPath: basepath,
			},
		})
			.then((res) => {
				if (res?.mysql?.jobID) {
					var jobID = res.mysql.jobID;
					beginConvertToPDFJob(
						jobID,
						fileToConvert,
						successCallback
					)(dispatch);
					dispatch({ type: CONVERT_TO_PDF_STARTED });
				}
			})
			.catch(({ lxwErrorCode, lxwErrorData }) => {
				if (lxwErrorCode === 6503) {
					const {
						fileName,
						newDocName,
						//duplicateDocID,
						isDocumentInUse,
						isOriginalPdfNameInTrash,
					} = lxwErrorData;
					var documentInUseMessage = `"${fileName}" is in use or checked-out by any other user. Can't create New Version of this file.`;
					var documentInTrashMessage = `"${fileName}" is in the Trash Bin. Can't create New Version of this file.`;
					openGlobalDialog(
						{
							label: `Duplicate File(s) Found`,
							mainText: `There is already a PDF named "${fileName}" Would you like to`,
							canSubmit: true,
							hideTextfield: true,
							type: "docTOPDF",
							readOnly: true,
							hideCancelButton: true,
							extraCSSClass: "WideEditDialog",
							value: {
								newDocName,
								fileName,
								isDocumentInUse,
								documentInUseMessage,
								documentInTrashMessage,
								isOriginalPdfNameInTrash,
							},
						},
						(state) => {
							if (state.convertToPDFAsNewVersion) {
								return convertDocumentToPDF({
									sourceDocumentID,
									fileToConvert,
									matterID,
									actionType: "createVersion",
									basepath,
								})(dispatch);
							} else {
								return convertDocumentToPDF({
									sourceDocumentID,
									fileToConvert,
									matterID,
									actionType: "createCopy",
									duplicatePDFDocInfo: {
										newUniquePdfName: newDocName,
									},
									basepath,
								})(dispatch);
							}
						},
						() => ({ canSubmit: true }),
						() => {
							dispatch({
								type: CONVERT_TO_PDF_CANCELED,
							});
						}
					)(dispatch);
				} else if (isPreventActionOnDeletedResource(lxwErrorCode)) {
					// handled in errorActions
				} else {
					// removes the loading blocker on other failures
					dispatch({
						type: "_FAILURE",
					});
				}
			});
	};
}

export function externalSendMultiple(
	selectedObjects,
	parentDirectoryPath,
	matterID,
	recipients,
	message,
	passwordProtectShare
) {
	return function (dispatch) {
		const successCallback = () => {
			dispatch({
				type: EXTERNAL_SEND_SUCCESS,
			});
		};
		const failureCallback = () => {
			dispatch({
				type: EXTERNAL_SEND_FAILURE,
			});
		};

		dispatch({ type: EXTERNAL_SEND_REQUEST });

		API.post("/multi/externalSend", {
			body: {
				selectedObjects,
				documentOrEmail: "Document",
				parentDirectoryPath,
				matterID,
				recipients,
				message,
				passwordProtectShare,
			},
		})
			.then((res) => {
				if (res?.mysql?.jobID) {
					var jobID = res.mysql.jobID;
					var sharePassword = res.mysql.sharePassword || null;
					var shareID = res.mysql.shareID || null;

					beginBulkExternalSendJob(
						jobID,
						sharePassword,
						shareID,
						successCallback,
						failureCallback
					)(dispatch);
					dispatch({ type: EXTERNAL_SEND_STARTED });
				}
				if (res && res.mysql && res.mysql.externalEmailAddresses) {
					dispatch({
						type: GET_EXTERNAL_SAVED_EMAIL_ADDRESSES_SUCCESS,
						payload: res.mysql.externalEmailAddresses,
					});
				}
			})
			.catch(() => {
				// removes the loading blocker on all failures
				dispatch({
					type: "GET_EXTERNAL_SAVED_EMAIL_ADDRESSES_FAILURE",
				});
			});
	};
}

export function downloadMultiple(
	selectedObjects,
	objectTypesToInclude,
	parentDirectoryPath,
	matterID
) {
	return function (dispatch) {
		const successCallback = () => {
			dispatch({
				type: MULTI_DOWNLOAD_SUCCESS,
			});
		};
		const failureCallback = () => {
			dispatch({
				type: MULTI_DOWNLOAD_FAILURE,
			});
		};

		dispatch({ type: MULTI_DOWNLOAD_REQUEST });

		API.post("/multi/download", {
			body: {
				selectedObjects,
				objectTypesToInclude,
				parentDirectoryPath,
				matterID,
			},
		})
			.then((res) => {
				if (res?.mysql?.jobID) {
					var jobID = res.mysql.jobID;

					beginBulkDownloadJob(
						jobID,
						false,
						successCallback,
						failureCallback
					)(dispatch);
					dispatch({ type: MULTI_DOWNLOAD_STARTED });
				}
			})
			.catch(failureCallback);
	};
}

export function openDocumentInLauncher(documentID, cognitoSub) {
	return function (dispatch) {
		if (!cognitoSub) {
			console.warn("cognito sub not being passed!");
		}
		const launcherOpenAttempt = openLauncherLink(
			"docs/" + documentID + `?cognitoSub=${cognitoSub}`
		);
		if (launcherOpenAttempt) {
			dispatch({
				type: OPEN_GLOBAL_SNACKBAR,
				payload: {
					message: "Opening Document...",
					loadingSpinnerVisible: true,
					autoHideDuration: 7000,
					allowClose: false,
					disableWindowBlurListener: true,
				},
			});
		} else {
			dispatch({
				type: OPEN_GLOBAL_SNACKBAR,
				payload: {
					message:
						"Could not connect to launcher.  Please see error console for details or contact support",
					variant: "error",
					loadingSpinnerVisible: false,
					allowClose: true,
					disableWindowBlurListener: true,
				},
			});
		}
	};
}
export function createNewFolder(matterID, basepath, dirname) {
	return function (dispatch) {
		dispatch({
			type: CREATE_NEW_FOLDER_REQUEST,
		});
		API.put("/directory", {
			body: { matterID, basepath, dirname },
		})
			.then(() => {
				if (basepath[0] === "/") {
					basepath = basepath.substr(1, basepath.length - 1);
				}
				dispatch({
					type: CREATE_NEW_FOLDER_SUCCESS,
				});
				listDirectory(matterID, basepath)(dispatch);
			})
			.catch(() => {
				dispatch({
					type: CREATE_NEW_FOLDER_FAILURE,
				});
			});
	};
}
// onSuccess: optional refresh to run instead of re-listing basepath
export function changeFolderName(
	matterID,
	directoryID,
	dirname,
	basepath,
	onSuccess
) {
	return function (dispatch) {
		dispatch({ type: RENAME_REQUEST });

		function success() {
			dispatch({ type: RENAME_SUCCESS });
			onSuccess
				? onSuccess()
				: listDirectory(matterID, basepath)(dispatch);
		}
		function failure() {
			console.log("rename failure");
			dispatch({ type: RENAME_FAILURE });
		}

		API.post("/directory/rename", {
			body: { matterID, directoryID, dirname },
		})
			.then((res) => {
				beginRenameJob(res.mysql.jobID, success, failure)(dispatch);
			})
			.catch(() => {
				dispatch({
					type: CREATE_NEW_FOLDER_FAILURE,
				});
			});
	};
}
// onSuccess: optional refresh to run instead of re-listing basepath
export function renameDocument(
	documentID,
	newDocumentName,
	matterID,
	basepath,
	onSuccess
) {
	return function (dispatch) {
		dispatch({ type: RENAME_REQUEST });

		function success() {
			dispatch({ type: RENAME_SUCCESS });
			onSuccess
				? onSuccess()
				: listDirectory(matterID, basepath)(dispatch);
		}
		function failure() {
			console.log("rename failure");
			dispatch({ type: RENAME_FAILURE });
		}

		API.post("/document/rename", {
			body: { documentID, newDocumentName },
		})
			.then(success)
			.catch(failure);
	};
}

export function showRenameDocumentDialog({
	documentID,
	currentName,
	matterID,
	apiBasepath,
	currentLocationFilesAndFolders,
	onSuccess,
}) {
	return function (dispatch) {
		const { basename, extension } = splitFilename(currentName);

		openGlobalDialog(
			{
				label: "New Document Name",
				value: basename,
				submitButtonLabel: "Rename Document",
				suffix: extension,
			},
			(state) => {
				renameDocument(
					documentID,
					state.value + (extension ? "." + extension : ""),
					matterID,
					apiBasepath,
					onSuccess
				)(dispatch);
			},
			(state) => {
				//Check for case-insensitive duplicate in current folder
				const matchesFilename = currentLocationFilesAndFolders.filter(
					(item) =>
						item.type === "File" &&
						item.filename.toUpperCase() ===
							`${state.value}.${extension}`.toUpperCase() &&
						item.id !== documentID
				).length;
				const deletedFileMatch = currentLocationFilesAndFolders.filter(
					(item) =>
						item.type === "File" &&
						item.filename.toUpperCase() ===
							`${state.value}.${extension}`.toUpperCase() &&
						item.id !== documentID &&
						item.documentLifecycleStatus !== NORMAL_LIFECYCLE_STATUS
				).length;

				const isEmpty =
					state.value.match(/^$/) || state.value.match(/^\s/);
				const hasIllegalCharacters = state.value.match(/[<>:"/\\|?*%]/);
				return {
					canSubmit:
						!isEmpty && !matchesFilename && !hasIllegalCharacters,
					errorMessage: matchesFilename
						? "There is already a " +
							(deletedFileMatch ? "deleted" : "") +
							" file in the current directory with this name"
						: hasIllegalCharacters
							? 'New File names cannot contain any of the following characters: < > : " / \\ | ? * %'
							: isEmpty
								? "Please enter a new file name"
								: "",
				};
			}
		)(dispatch);
	};
}

export function renameDocumentFromDocumentProperties(
	documentID,
	newDocumentName,
	containingDirectoryLocation
) {
	return function (dispatch) {
		dispatch({ type: RENAME_REQUEST });

		function success() {
			dispatch({ type: RENAME_SUCCESS });
			window.safeGoBack(containingDirectoryLocation);
		}
		function failure() {
			console.log("rename failure");
			dispatch({ type: RENAME_FAILURE });
		}

		API.post("/document/rename", {
			body: { documentID, newDocumentName },
		})
			.then(success)
			.catch(failure);
	};
}

export function updateVersionComment(
	documentID,
	versionNumber,
	versionID,
	comment
) {
	return function (dispatch) {
		dispatch({ type: UPDATE_DOCUMENT_VERSION_COMMENT_REQUEST });
		API.post("/document/version/comment", {
			body: { documentID, versionNumber, versionID, comment },
		})
			.then(() => {
				dispatch({ type: UPDATE_DOCUMENT_VERSION_COMMENT_SUCCESS });
				getDocumentDetailsBackground(documentID)(dispatch);
			})
			.catch(() => {
				dispatch({ type: UPDATE_DOCUMENT_VERSION_COMMENT_FAILURE });
			});
	};
}

export function updateMajorVersionComment(
	documentID,
	majorVersionNum,
	comment
) {
	return function (dispatch) {
		dispatch({ type: UPDATE_DOCUMENT_VERSION_COMMENT_REQUEST });
		API.post("/document/version/majorComment", {
			body: { documentID, majorVersionNum, comment },
		})
			.then(() => {
				dispatch({ type: UPDATE_DOCUMENT_VERSION_COMMENT_SUCCESS });
				getDocumentDetailsBackground(documentID)(dispatch);
			})
			.catch(() => {
				dispatch({ type: UPDATE_DOCUMENT_VERSION_COMMENT_FAILURE });
			});
	};
}
function insertVersionRecords(versionData) {
	return API.put("/document/version", {
		body: { versionData },
	});
}
export function uploadNewVersion(
	documentID,
	files,
	callback,
	isNewVersion = true,
	comment = null
) {
	return function (dispatch) {
		dispatch({
			type: UPLOAD_NEW_VERSION_REQUEST,
		});
		dispatch({
			type: UPLOAD_NEW_VERSION_PROGRESS,
			payload: {
				message: `Uploading new version of "${files[0].name}"`,
			},
		});
		const uploadMetadata = {
			uploadSource: "web",
			modifiedDate: "" + files[0].lastModified,
		};
		uploadFileToS3({
			file: files[0],
			documentID,
			isNewVersion,
			versionComment: isNewVersion ? comment : null,
			metadata: uploadMetadata,
		})
			.then((res) =>
				insertVersionRecords([
					{
						documentID,
						versionID: res.headers["x-amz-version-id"],
						filesize: files[0].size,
						saveAsNewVersion: isNewVersion,
						comment: isNewVersion ? comment : null,
					},
				])
			)
			.then(() => {
				getDocumentDetails(documentID)(dispatch);
				dispatch({
					type: UPLOAD_NEW_VERSION_SUCCESS,
					payload: { filename: files[0].name },
				});
				callback && callback();
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err?.lxwErrorCode)) {
					// handled in errorActions
				} else {
					// dispatching this on an error prevents the loading blocker from staying on the screen
					dispatch({ type: "_FAILURE" });
					console.log("error uploading new version", err);
				}
			});
	};
}

function uploadFileToS3({
	file,
	documentID,
	isNewVersion,
	versionComment,
	metadata,
}) {
	return new Promise((resolve, reject) => {
		API.post("/checkTrashAndGetSignedUrlForDocumentUpload", {
			body: {
				documentID,
				contentType: file.type,
				isNewVersion,
				versionComment,
				metadata,
				restrictVersionUploadIfInUseByMe: true,
			},
		})
			.then((res) => uploadFileRequest(res.mysql.url, file))
			.then((res) => resolve(res))
			.catch((err) => reject(err));
	});
}

export async function uploadFileRequest(url, file) {
	const res = await fetch(url, {
		method: "PUT",
		headers: {
			"Content-Type": file.type,
		},
		body: file,
	});

	if (!res.ok) {
		throw new Error(`S3 upload failed with status ${res.status}`);
	}

	return {
		headers: Object.fromEntries(res.headers.entries()),
	};
}

function determineTrashPageContext() {
	const windowPath = window.location.pathname;
	const trashPageContext = windowPath.split("/").filter(Boolean)[1];
	// ex: /trash/docs
	// split gets: ["", "trash", "docs"]
	// filter removes empty string
	// ["trash", "docs"]
	// [1] gets the second item
	// "docs"
	return trashPageContext;
}
function deleteMaker(resource, deleteOrRestore) {
	return function (IDs, matterID, basepath) {
		var selectedItems = { Object: {}, Folder: {} };
		switch (resource) {
			case "document":
				selectedItems.Object[IDs[0]] = { id: IDs[0], type: "File" };
				break;
			case "email":
				selectedItems.Object[IDs[0]] = { id: IDs[0], type: "Email" };
				break;
			case "notes":
				selectedItems.Object[IDs[0]] = { id: IDs[0], type: "Note" };
				break;
			case "directory":
				selectedItems.Folder[IDs[0]] = { id: IDs[0], type: "Folder" };
				break;
			case "matter":
				selectedItems.Object[IDs[0]] = { id: IDs[0], type: "Matter" };
				break;
			case "client":
				selectedItems.Object[IDs[0]] = { id: IDs[0], type: "Client" };
				break;
			default:
				console.log("I should not be seen");
		}
		if (deleteOrRestore === "delete") {
			return deleteMultiselect(selectedItems, matterID, basepath);
		} else if (deleteOrRestore === "restore") {
			return restoreMultiselect(selectedItems, matterID, basepath);
		} else if (deleteOrRestore === "restoreFromArchive") {
			return restoreFromArchiveMultiselect(
				selectedItems,
				matterID,
				basepath
			);
		} else if (deleteOrRestore === "archive") {
			return archiveMultiselect(selectedItems, matterID, basepath);
		} else if (deleteOrRestore === "generatePermanentDeleteManifest") {
			return generatePermanentDeleteManifest({
				selectedItems,
				trashPageContext: determineTrashPageContext(),
			});
		} else if (deleteOrRestore === "restoreFromTrashPage") {
			return restoreMultiSelectTrashPage({
				selectedItems,
				trashPageContext: determineTrashPageContext(),
			});
		}
	};
}
export function generatePermanentDeleteManifestFromTrashList({
	trashList,
	trashPageContext,
}) {
	// we need to transform the trashList into the format that generatePermanentDeleteManifest expects
	let selectedItems = { Object: {}, Folder: {} };
	trashList.forEach((item) => {
		if (item.type === "File") {
			selectedItems.Object[item.id] = { id: item.id, type: "File" };
		} else if (item.type === "Email") {
			selectedItems.Object[item.id] = { id: item.id, type: "Email" };
		} else if (item.type === "Note") {
			selectedItems.Object[item.id] = { id: item.id, type: "Note" };
		} else if (item.type === "Folder") {
			selectedItems.Folder[item.id] = { id: item.id, type: "Folder" };
		} else if (item.type === "Matter") {
			selectedItems.Object[item.id] = { id: item.id, type: "Matter" };
		} else if (item.type === "Client") {
			selectedItems.Object[item.id] = { id: item.id, type: "Client" };
		}
	});
	return generatePermanentDeleteManifest({
		selectedItems,
		trashPageContext,
	});
}
export function generatePermanentDeleteManifest({
	selectedItems,
	trashPageContext,
}) {
	var IDs = {
		Folder: [],
		File: [],
		Email: [],
		Note: [],
		Matter: [],
		Client: [],
	};
	Object.keys(selectedItems.Object).forEach((key) => {
		IDs[selectedItems.Object[key].type].push(selectedItems.Object[key].id);
	});
	Object.keys(selectedItems.Folder).forEach((key) => {
		IDs[selectedItems.Folder[key].type].push(selectedItems.Folder[key].id);
	});
	let objectTypesToIncludeObject = {
		Document: 0,
		Email: 0,
		Note: 0,
		Folder: 0,
		Matter: 0,
		Client: 0,
	};
	if (IDs.File.length > 0) {
		objectTypesToIncludeObject.Document = 1;
	}
	if (IDs.Email.length > 0) {
		objectTypesToIncludeObject.Email = 1;
	}
	if (IDs.Note.length > 0) {
		objectTypesToIncludeObject.Note = 1;
	}
	if (IDs.Matter.length > 0) {
		// include all object types
		objectTypesToIncludeObject.Document = 1;
		objectTypesToIncludeObject.Email = 1;
		objectTypesToIncludeObject.Note = 1;
	}
	if (IDs.Client.length > 0) {
		// only include client
		objectTypesToIncludeObject.Client = 1;
	}
	if (IDs.Folder.length > 0) {
		if (trashPageContext === "docs") {
			objectTypesToIncludeObject.Document = 1;
		}
		if (trashPageContext === "email") {
			objectTypesToIncludeObject.Email = 1;
		}
		if (trashPageContext === "notes") {
			objectTypesToIncludeObject.Note = 1;
		}
	}
	const objectTypesToInclude = Object.entries(objectTypesToIncludeObject)
		.filter(([, value]) => value === 1)
		.map(([key]) => key);
	return function (dispatch, getState) {
		dispatch({ type: "DELETE_MULTIPLE_REQUEST" });
		API.post("/trash/generatePermanentDeleteManifest", {
			body: {
				IDs,
				objectTypesToInclude,
			},
		})
			.then((res) => {
				if (res?.mysql?.jobID) {
					handlePermanentDeleteFlow({
						jobID: res.mysql.jobID,
						objectIDs: IDs,
						trashPageContext,
					})(dispatch, getState);
				}
				dispatch({ type: "DELETE_MULTIPLE_SUCCESS" });
			})
			.catch(() => {
				dispatch({ type: "DELETE_MULTIPLE_FAILURE" });
			});
	};
}

export const deleteDocuments = deleteMaker("document", "delete");
export const restoreDocuments = deleteMaker("document", "restore");
export const archiveDocuments = deleteMaker("document", "archive");
export const restoreDocumentsFromArchive = deleteMaker(
	"document",
	"restoreFromArchive"
);
export const restoreFromTrashPageDocuments = deleteMaker(
	"document",
	"restoreFromTrashPage"
);
// permanent delete will need to have a confirm dialog at some point
// look at deleteVersion for an example
export const generatePermanentDeleteManifestForDocuments = deleteMaker(
	"document",
	"generatePermanentDeleteManifest"
);

export const deleteFolders = deleteMaker("directory", "delete");
export const restoreFolders = deleteMaker("directory", "restore");
export const archiveFolders = deleteMaker("directory", "archive");
export const restoreFoldersFromArchive = deleteMaker(
	"directory",
	"restoreFromArchive"
);
export const restoreFromTrashPageFolders = deleteMaker(
	"directory",
	"restoreFromTrashPage"
);
export const generatePermanentDeleteManifestForFolders = deleteMaker(
	"directory",
	"generatePermanentDeleteManifest"
);

export const deleteEmails = deleteMaker("email", "delete");
export const restoreEmails = deleteMaker("email", "restore");
export const archiveEmails = deleteMaker("email", "archive");
export const restoreEmailsFromArchive = deleteMaker(
	"email",
	"restoreFromArchive"
);

export const restoreFromTrashPageEmails = deleteMaker(
	"email",
	"restoreFromTrashPage"
);
export const generatePermanentDeleteManifestForEmails = deleteMaker(
	"email",
	"generatePermanentDeleteManifest"
);

export const deleteNotes = deleteMaker("notes", "delete");
export const restoreNotes = deleteMaker("notes", "restore");
export const archiveNotes = deleteMaker("notes", "archive");
export const restoreNotesFromArchive = deleteMaker(
	"notes",
	"restoreFromArchive"
);
export const restoreFromTrashPageNotes = deleteMaker(
	"notes",
	"restoreFromTrashPage"
);
export const generatePermanentDeleteManifestForNotes = deleteMaker(
	"notes",
	"generatePermanentDeleteManifest"
);

export const generatePermanentDeleteManifestForMatters = deleteMaker(
	"matter",
	"generatePermanentDeleteManifest"
);

export const generatePermanentDeleteManifestForClients = deleteMaker(
	"client",
	"generatePermanentDeleteManifest"
);

export function deleteVersion({
	documentID,
	versionID,
	versionNumber,
	versionLabel,
	itemNoun,
}) {
	return function (dispatch) {
		const displayLabel = versionLabel ?? `v${versionNumber}`;
		openGlobalDialog(
			{
				label: `Permanently Delete this ${itemNoun}?`,
				mainText: `This will permanently delete ${displayLabel} of this document.  This operation cannot be undone.  Are you sure?`,
				canSubmit: true,
				hideTextfield: true,
				submitButtonLabel: `Permanently Delete this ${itemNoun}`,
			},
			() => {
				dispatch({ type: DELETE_DOCUMENT_VERSION_REQUEST });
				deleteVersionRecord(documentID, versionID)
					.then(() => {
						dispatch({ type: DELETE_DOCUMENT_VERSION_SUCCESS });
					})
					.catch(() => {
						dispatch({ type: DELETE_DOCUMENT_VERSION_FAILURE });
					})
					.finally(() => {
						getDocumentDetailsBackground(documentID)(dispatch);
					});
			}
		)(dispatch);
	};
}
function deleteVersionRecord(documentID, versionID) {
	return API.post("/document/version/delete", {
		queryParams: { documentID, versionID },
	});
}

export function deleteMajorVersion({ documentID, major }) {
	return function (dispatch) {
		openGlobalDialog(
			{
				label: `Delete All Saves for v${major}?`,
				mainText: `This will permanently delete all saves for version v${major}. This cannot be undone.`,
				canSubmit: true,
				hideTextfield: true,
				submitButtonLabel: `Delete All Saves for v${major}`,
			},
			() => {
				dispatch({ type: DELETE_MAJOR_VERSION_REQUEST });
				API.post("/document/version/deleteMajor", {
					queryParams: { documentID, major },
				})
					.then(() => {
						dispatch({ type: DELETE_MAJOR_VERSION_SUCCESS });
						getDocumentDetailsBackground(documentID)(dispatch);
					})
					.catch(() => {
						dispatch({ type: DELETE_MAJOR_VERSION_FAILURE });
					});
			}
		)(dispatch);
	};
}

export function promoteDocumentToNextMajorVersion(
	documentID,
	versionID,
	nextMajorVerNum
) {
	return function (dispatch) {
		openGlobalDialog(
			{
				label: `Promote to v${nextMajorVerNum}`,
				canSubmit: true,
				submitButtonLabel: `Promote to v${nextMajorVerNum}`,
				useTextarea: true,
				maxLength: 1000,
				placeHolder: "Version Comment (optional)",
			},
			(state) => {
				dispatch({ type: PROMOTE_DOCUMENT_VERSION_REQUEST });
				API.put("/document/promoteToNextMajorVersion", {
					body: {
						documentID,
						versionID,
						comment: state.value || null,
					},
				})
					.then(() => {
						dispatch({ type: PROMOTE_DOCUMENT_VERSION_SUCCESS });
						getDocumentDetailsBackground(documentID)(dispatch);
					})
					.catch(() => {
						dispatch({ type: PROMOTE_DOCUMENT_VERSION_FAILURE });
					});
			}
		)(dispatch);
	};
}

function updateDocumentPropertiesHelper(documentProperties) {
	// Only send fields that backend actually uses
	return {
		documentName:
			documentProperties.extension === ""
				? documentProperties.basename
				: documentProperties.basename +
					"." +
					documentProperties.extension,
		tags:
			documentProperties.documentTags &&
			documentProperties.documentTags.length
				? documentProperties.documentTags.map((tag) => tag.label)
				: [],
		documentStatusName: documentProperties.documentStatus
			? documentProperties.documentStatus.value
			: null,
		documentTypeName: documentProperties.documentType
			? documentProperties.documentType.value
			: null,
		documentNotes: documentProperties.documentNotes,
		excludeDocumentFromStamping:
			documentProperties.excludeDocumentFromStamping,
		extension: documentProperties.extension,
	};
}
export function updateDocumentProperties(
	documentID,
	documentProperties,
	containingDirectoryLocation
) {
	return function (dispatch) {
		const newProps = updateDocumentPropertiesHelper(documentProperties);
		dispatch({ type: UPDATE_DOCUMENT_PROPERTIES_REQUEST });
		API.post("/document", {
			body: { documentID, documentProperties: newProps },
		})
			.then(() => {
				dispatch({ type: UPDATE_DOCUMENT_PROPERTIES_SUCCESS });
				window.safeGoBack(containingDirectoryLocation);
			})
			.catch((err) => {
				dispatch({ type: UPDATE_DOCUMENT_PROPERTIES_FAILURE });
				console.log(err);
			});
	};
}

export function setDocumentLifecycleStatus(documentID, lifecycleStatus) {
	return function (dispatch) {
		dispatch({ type: "TOGGLE_DELETE_DOC_PROPERTIES_REQUEST" });
		const apiToUse =
			lifecycleStatus === TRASH_LIFECYCLE_STATUS
				? "/multi/v2/delete"
				: lifecycleStatus === ARCHIVE_LIFECYCLE_STATUS
					? "/multi/v2/archive"
					: "/multi/v2/restore";
		API.post(apiToUse, {
			body: { IDs: { File: [documentID] }, objectType: "Documents" },
		})
			.then(() => {
				getDocumentDetails(documentID)(dispatch);
			})
			.catch(() => {
				dispatch({ type: "TOGGLE_DELETE_DOC_PROPERTIES_FAILURE" });
			});
	};
}

export function setNoteLifecycleStatus(noteID, lifecycleStatus) {
	return function (dispatch) {
		const apiToUse =
			lifecycleStatus === TRASH_LIFECYCLE_STATUS
				? "/multi/v2/delete"
				: "/multi/v2/restore";
		return API.post(apiToUse, {
			body: { IDs: { Note: [noteID] }, objectType: "Notes" },
		})
			.then(() => getNote(noteID)(dispatch))
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err?.lxwErrorCode)) {
					// handled in errorActions
					return;
				}
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						message:
							lifecycleStatus === TRASH_LIFECYCLE_STATUS
								? "Unable to move note to the Trash Bin"
								: "Unable to restore note from the Trash Bin",
						variant: "error",
					},
				});
			});
	};
}

export function setFavoriteDocumentProperties(documentID, isFavorite) {
	return function (dispatch) {
		// dispatch a _REQUEST to add a loading blocker to prevent user from clicking the button many times
		dispatch({
			type: "TOGGLE_FAVORITE_DOC_PROPERTIES_REQUEST",
		});
		return API.post("/document/favorite", {
			body: { documentID, isFavorite },
		})
			.then(() => {
				// update the state with the new favorite status and removes the loading blocker
				dispatch({
					type: "TOGGLE_FAVORITE_DOC_PROPERTIES_SUCCESS",
					payload: {
						isFavorite,
					},
				});
			})
			.catch(() => {
				// remove the loading blocker
				dispatch({
					type: "TOGGLE_FAVORITE_DOC_PROPERTIES_FAILURE",
				});
			});
	};
}

export function setFavorite(
	documentID,
	isFavorite,
	matterID,
	basepath,
	documentData
) {
	return function (dispatch) {
		dispatch({ type: "TOGGLE_FAVORITE_REQUEST" });
		return API.post("/document/favorite", {
			body: { documentID, isFavorite },
		})
			.then(() => {
				dispatch({
					type: "TOGGLE_FAVORITE_SUCCESS",
					payload: { isFavorite, documentData },
				});
				if (matterID !== undefined && basepath !== undefined) {
					listDirectory(matterID, basepath)(dispatch);
				}
			})
			.catch(() => {
				dispatch({
					type: "TOGGLE_FAVORITE_FAILURE",
				});
			});
	};
}
export function setFavoriteFolder(folderID, isFavorite, matterID, basepath) {
	return function (dispatch) {
		API.post("/document/favoriteFolder", { body: { folderID, isFavorite } })
			.then(() => {
				dispatch({
					type: "TOGGLE_FAVORITE_SUCCESS",
				});
				if (matterID !== undefined && basepath !== undefined) {
					listDirectory(matterID, basepath)(dispatch);
				}
			})
			.catch(() => {
				dispatch({
					type: "TOGGLE_FAVORITE_FAILURE",
				});
			});
	};
}

export function unmountDocumentProperties() {
	return function (dispatch) {
		dispatch({
			type: UNMOUNT_DOCUMENT_DETAILS,
		});
	};
}
export function setLockStatus(documentID, lockStatus, basepath, matterID) {
	return function (dispatch) {
		API.post("/document/lock", {
			body: {
				documentID,
				lockStatus,
			},
		})
			.then(() => {
				dispatch({
					type: SET_DOCUMENT_LOCK_SUCCESS,
					payload: { lockStatus },
				});
				if (basepath) {
					//hacky way to determine if user is on document list or document properties
					listDirectory(matterID, basepath)(dispatch);
				} else {
					getDocumentDetails(documentID)(dispatch);
				}
			})
			.catch(() => {});
	};
}
export function getRecentDocsAndMatters() {
	return function (dispatch, getState) {
		const recentMatterIDs = getRecentlyViewMatters()(dispatch, getState);
		const recentClientIDs = getRecentlyViewedClients()(dispatch, getState);
		dispatch({ type: FETCH_RECENT_DOCS_REQUEST_NOGLOBAL });
		API.post("/document/recentDocsAndMatters", {
			body: { recentMatterIDs, recentClientIDs },
		})
			.then((res) => {
				dispatch({
					type: FETCH_RECENT_DOCS_SUCCESS_NOGLOBAL,
					payload: res.mysql,
				});
			})
			.catch(() => {
				console.error("error getting /document/recentDocsAndMatters");
			});
	};
}
export function getFavoriteDocs() {
	return function (dispatch) {
		dispatch({ type: FETCH_FAVORITE_DOCS_REQUEST_NOGLOBAL });
		API.get("/document/listFavorites")
			.then((res) => {
				dispatch({
					type: FETCH_FAVORITE_DOCS_SUCCESS_NOGLOBAL,
					payload: res.mysql,
				});
			})
			.catch(() => {
				console.error("error getting /document/listFavorites");
			});
	};
}

export function aiConversationAboutDocument({
	documentID,
	userPrompt,
	priorMessages,
}) {
	//return function(dispatch) {
	return API.post("/ai/conversation", {
		body: { documentID, userPrompt, priorMessages },
	}).then((res) => {
		return res.mysql;
	});
	//};
}

export function summarizeDocument(documentID, versionNumber) {
	return API.post("/ai/summarize", {
		body: { documentID, versionNumber },
	}).then((res) => {
		return res.mysql;
	});
}

export function suggestQuestions(documentID, versionNumber) {
	return API.post("/ai/suggest", {
		body: { documentID, versionNumber },
	}).then((res) => {
		return res.mysql;
	});
}
export function getContentForDocumentPreview({
	documentID,
	versionNumber,
	versionID,
	emailID,
	noteID,
	matterID,
	previewType,
}) {
	return function (dispatch) {
		dispatch({ type: FETCH_DOCUMENT_PREVIEW_CONTENT });
		var apiCall, documentPreviewContent;
		if (previewType === "Document") {
			apiCall = API.post("/document/preview", {
				body: {
					documentID,
					versionNumber,
				},
			});
		} else if (previewType === "Email") {
			apiCall = API.post("/email/preview", {
				body: {
					emailID,
				},
			});
		} else if (previewType === "Image") {
			apiCall = API.get("/signedGetIgnoreLock", {
				queryParams: { documentID, versionID },
			});
		} else if (previewType === "PDF") {
			apiCall = API.get("/signedGetIgnoreLock", {
				queryParams: {
					documentID,
					versionID,
					contentDispositionHeaderType: "INLINE",
					responseContentTypeEnum: "PDF",
				},
			});
		} else if (previewType === "Docx") {
			apiCall = API.get("/signedGetIgnoreLock", {
				queryParams: { documentID, versionID },
			});
		} else if (previewType === "Excel") {
			apiCall = API.get("/signedGetIgnoreLock", {
				queryParams: { documentID, versionID },
			});
		} else if (previewType === "MatterNote") {
			apiCall = API.post("/notes/preview", {
				body: { noteID },
			});
		} else if (previewType === "Matter") {
			apiCall = API.get("/matter", {
				queryParams: { matterID },
			});
		}
		apiCall
			.then((res) => {
				if (res && res.mysql) {
					if (previewType === "Image") {
						documentPreviewContent = {
							url: res.mysql.url,
							isFavorite: res.mysql.isFavorite,
							lockedBySub: res.mysql.lockedBySub,
							documentLifecycleStatus:
								res.mysql.documentLifecycleStatus,
							noS3Object: res.mysql.noS3Object,
						};
						dispatch({
							type: DOCUMENT_PREVIEW_CONTENT_SUCCESS,
							payload: documentPreviewContent,
						});
					} else if (previewType === "Docx") {
						documentPreviewContent = {
							docxUrl: res.mysql.url,
							isFavorite: res.mysql.isFavorite,
							lockedBySub: res.mysql.lockedBySub,
							documentLifecycleStatus:
								res.mysql.documentLifecycleStatus,
							noS3Object: res.mysql.noS3Object,
						};
						dispatch({
							type: DOCUMENT_PREVIEW_CONTENT_SUCCESS,
							payload: documentPreviewContent,
						});
					} else if (previewType === "Excel") {
						documentPreviewContent = {
							excelUrl: res.mysql.url,
							isFavorite: res.mysql.isFavorite,
							lockedBySub: res.mysql.lockedBySub,
							documentLifecycleStatus:
								res.mysql.documentLifecycleStatus,
							noS3Object: res.mysql.noS3Object,
						};
						dispatch({
							type: DOCUMENT_PREVIEW_CONTENT_SUCCESS,
							payload: documentPreviewContent,
						});
					} else if (previewType === "PDF") {
						documentPreviewContent = {
							pdfUrl: res.mysql.url,
							isFavorite: res.mysql.isFavorite,
							lockedBySub: res.mysql.lockedBySub,
							documentLifecycleStatus:
								res.mysql.documentLifecycleStatus,
							noS3Object: res.mysql.noS3Object,
						};
						dispatch({
							type: DOCUMENT_PREVIEW_CONTENT_SUCCESS,
							payload: documentPreviewContent,
						});
					} else if (previewType === "Matter") {
						dispatch({
							type: DOCUMENT_PREVIEW_CONTENT_SUCCESS,
							payload: res.mysql[0],
						});
					} else {
						dispatch({
							type: DOCUMENT_PREVIEW_CONTENT_SUCCESS,
							payload: res.mysql,
						});
					}
				} else {
					dispatch({
						type: DOCUMENT_PREVIEW_CONTENT_FAILURE,
					});
				}
			})
			.catch(() => {
				dispatch({ type: DOCUMENT_PREVIEW_CONTENT_FAILURE });
			});
	};
}
export function copyDocLinkToClipboard(documentID) {
	return function (dispatch) {
		let docUrl = window.location.origin + "/docs/" + documentID;
		navigator.clipboard
			.writeText(docUrl)
			.then(() => {
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						message: "Document URL copied to clipboard",
						variant: "success",
					},
				});
			})
			.catch(() => {
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						message: "Unable to copy Document URL to clipboard",
						variant: "error",
					},
				});
			});
	};
}

export function copyNoteLinkToClipboard(noteID) {
	return function (dispatch) {
		navigator.clipboard
			.writeText(window.location.origin + "/notes/" + noteID)
			.then(() => {
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						message: "Note URL copied to clipboard",
						variant: "success",
					},
				});
			})
			.catch(() => {
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						message: "Unable to copy Note URL to clipboard",
						variant: "error",
					},
				});
			});
	};
}

export function handleDisabledKeyBoardShortcut({ message }) {
	return function (dispatch) {
		dispatch({
			type: OPEN_GLOBAL_SNACKBAR,
			payload: {
				message,
				variant: "error",
			},
		});
	};
}
